<section class="section news" id="news">
  <h2 class="text-center">News</h2>
  <p class="text-center">We're causing mass disruption. See what's <br> being said about our solutions out in the world.</p>
  <div class="container">
    <div class="bl-colums-press">
      <div class="item">
        <div class="image">
          <img src="./assets/img/gennius/bg-inside-notice28.jpg" alt="">
        </div>
        <div class="bl-text">
          <span class="date">Jun 15, 2026 </span>
          <span>Gennius XYZ Launches ONED USD, a Stablecoin for Connected Value Ecosystems, Powered by Coinbase</span>
          <p>ONED USD by Gennius XYZ, a stablecoin purpose-built to unify rewards, payments, and digital assets across banking and financial technology partners globally</p>
          <a href="https://oned.global/#/press-room/oned-usd-expands-global-liquidity-network" class="more" target="_blank"></a>
        </div>

      </div>
      <div class="item">
        <div class="image">
          <img src="./assets/img/gennius/bg-inside-notice27.jpg" alt="">
        </div>
        <div class="bl-text">
          <span class="date">Feb 12, 2026 </span>
          <span>Gennius XYZ Completes Acquisition of Utoppia</span>
          <p><strong>Gennius</strong> expands its borderless financial infrastructure and accelerates its tokenized value ecosystem with <strong>Utoppia</strong>. Now operating as <strong>Utoppia by Gennius</strong>, the platform remains independently operated while fully integrated into a unified global operating model.</p>
          <a [routerLink]="['gennius-xyz-completes-acquisition-of-utoppia']" [routerLinkActive]="['active']" class="more"></a>
        </div>

      </div>
      <div class="item">
        <div class="image">
          <img src="./assets/img/cryptmi/bg-inside-notice26.webp" alt="">
        </div>
        <div class="bl-text">
          <span class="date">Jan 22, 2026 </span>
          <span>Ruben Salazar Genovez Named Top Financial Technology CEO of 2025</span>
          <p> <strong>Gennius XYZ CEO Ruben Salazar Genovez</strong> has been recognized by The Financial Technology Report as one of the Top Financial Technology CEOs of 2025, acknowledging his leadership within the global fintech industry.</p>
          <a href="https://thefinancialtechnologyreport.com/top-financial-technology-ceos-of-2025/" class="more" target="_blank"></a>
        </div>

      </div>

      <div class="item">
        <div class="image">
          <img src="./assets/img/cryptmi/bg-inside-notice25.png" alt="">
        </div>
        <div class="bl-text">
          <span class="date">Dec 18, 2025 </span>
          <span>Gennius XYZ Acquires TripPromoter</span>
          <p> The acquisition expands Gennius XYZ’s ecosystem and introduces <strong>Promie by Gennius,</strong>  a next-generation experiential commerce platform enabling creators to monetize influence across travel, lifestyle, entertainment, and digital experiences—powered by Gennius’ global payments, marketplace, and rewards tokenization infrastructure.</p>
          <a [routerLink]="['gennius-XYZ-acquires-TripPromoter-to-launch-an-experiential']"
            [routerLinkActive]="['active']" class="more"></a>
        </div>

      </div>

            <div class="item first-item">
        <img src="./assets/img/cryptmi/itempress-1.png" alt="">

        <div class="bl-text">
          <p>Nexthon gathers some of the most brilliant minds in the FinTech and InsurTech world. </p>
          <a href="https://novae.io/nexthon/five/" target="_blank" class="btn">Recap: Nexthon 5</a>
          <a href="https://novae.io/#/nexthon-blue" target="_blank" class="btn">Recap: Nexthon 4</a>
          <a href="https://wearenovae.com/nexthon/three/" target="_blank" class="btn">Recap: Nexthon 3</a>
          <a href="https://wearenovae.com/nexthon/two/" target="_blank" class="btn">Recap: Nexthon 2</a>
          <a href="https://wearenovae.com/nexthon/one/" target="_blank" class="btn">Recap: Nexthon 1</a>
        </div>
      </div>
      <div class="item">
          <div class="image">
            <img src="./assets/img/cryptmi/news24.webp" alt="">
          </div>
          <div class="bl-text">
            <span class="date">Nov 12, 2025</span>
            <span>Best Emerging Loyalty Payment Platform – GCC</span>
            <p class="points_value">As we expand our platform across Middle East and Africa, we are excited to be recognized as the “Best Emerging Loyalty Payment Platform – GCC” by the Global Brand Awards 2025. Explore all the winners for 2025!</p>
            <a href="https://www.globalbrandsmagazine.com/award-winners-2025/?id=410&cat_id=30189" class="more" target="_blank"></a>
          </div>

      </div>

      <div class="item">
          <div class="image">
            <img src="./assets/img/cryptmi/news23.png" alt="">
          </div>
          <div class="bl-text">
            <span class="date">Oct 28, 2025 </span>
            <span>Powering the Future of Bank Payments</span>
            <p class="points_value">Gennius XYZ has selected Thredd as its global issuer processing partner to enhance its loyalty and payment ecosystem. Merging Thredd’s scalable tech with Gennius XYZ’s digital innovation, the partnership helps banks offer faster, safer, and more personalized experiences. </p>
            <a href="https://www.thredd.com/about-us/newsroom/company-news/thredd-selected-by-gennius-xyz-as-global-issuer-processor-partner" class="more" target="_blank"></a>
          </div>

      </div>

      <div class="item">
          <div class="image">
            <img src="./assets/img/cryptmi/news22.webp" alt="">
          </div>
          <div class="bl-text">
            <span class="date">Oct 9, 2025 </span>
            <span>Transforming Bank Loyalty</span>
            <p class="points_value">Gennius XYZ and Dragonpass join forces to redefine how banks create value from loyalty programs. By integrating travel and lifestyle rewards into a unified digital experience, this partnership turns traditional points into premium, real-world benefits. </p>
            <a href="https://www.dragonpass.com/insights/dragonpass-and-gennius-xyz-join-forces-to-transform-bank-loyalty-points-into" target="_blank" class="more"></a>
          </div>
      </div>

      <div class="item">
          <div class="image">
            <img src="./assets/img/cryptmi/news21.png" alt="">
          </div>
          <div class="bl-text">
            <span class="date">May 26, 2025 </span>
            <span>Points to Value: Why We’re Unlocking the True Value of Rewards</span>
            <p class="points_value"> Most loyalty points sit unused—not because they’re unwanted, but because they lack real value. Discover how tokenization can turn them into flexible, spendable assets.</p>
            <a href="https://financialit.net/blog/rewardsinnovation-loyaltyeconomy/points-value-why-were-unlocking-true-value-rewards" class="more" target="_blank"></a>
          </div>
      </div>

      <div class="item">
        <div class="image">
          <img src="./assets/img/cryptmi/news20.png" alt="">
        </div>
        <div class="bl-text">
          <span class="date">May 13, 2025 </span>
          <span>When Points Become Digital Assets: Fuze and Gennius XYZ Push Rewards Tokenization</span>
          <p> <strong>Dubai, UAE</strong> – Loyalty rewards have long sat idle on corporate ledgers — expiring quietly, trapped inside...</p>
          <a [routerLink]="['when-points-become-digital-assets-fuze-and-gennius-xyz-push-rewards-tokenization']"
            [routerLinkActive]="['active']" class="more"></a>
        </div>
      </div>

      <div class="item">
        <div class="image">
          <img src="./assets/img/cryptmi/news19.png" alt="">
        </div>
        <div class="bl-text">
          <span class="date">May 12, 2025 </span>
          <span>Gennius XYZ Appoints Ana Velasquez as Managing Director for Latin America & Caribbean</span>
          <p> <strong>Miami, USA</strong> – Gennius XYZ continues to accelerate its global expansion with the appointment of Ana....</p>
          <a [routerLink]="['gennius-xyz-appoints-ana-velasquez-as-managing-director-for-latin-america-&-caribbean']"
            [routerLinkActive]="['active']" class="more"></a>
        </div>
      </div>

      <div class="item">
        <div class="image">
          <img src="./assets/img/cryptmi/news18.png" alt="">
        </div>
        <div class="bl-text">
          <span class="date">May 02, 2025 </span>
          <span>Gennius XYZ Appoints Öznur Demir as Vice President of Global Marketing</span>
          <p> <strong>Miami, USA</strong> – Gennius XYZ is proud to announce the appointment of Öznur Demir as Vice President of Global…</p>
          <a [routerLink]="['gennius-xyz-appoints-oznur-demir-as-vice-president-of-global-marketing']"
            [routerLinkActive]="['active']" class="more"></a>
        </div>
      </div>

      <div class="item">
        <div class="image">
          <img src="./assets/img/cryptmi/news17.png" alt="">
        </div>
        <div class="bl-text">
          <span class="date">Mar 17, 2025 </span>
          <span>Gennius XYZ Appoints Laura Gabrysiak Gomez as Vice President of AI and Analytics</span>
          <p> <strong>Miami, USA</strong> – Gennius XYZ is strengthening its commitment to AI-driven innovation with the…</p>
          <a [routerLink]="['gennius-xyz-appoints-laura-gabrysiak-gomez-as-vice-president-of-ai-and-analytics']"
            [routerLinkActive]="['active']" class="more"></a>
        </div>
      </div>

        <div class="item">
          <div class="image">
            <img src="./assets/img/cryptmi/news16.png" alt="">
          </div>
          <div class="bl-text">
            <span class="date">Jan 16, 2025 </span>
            <span>Gennius XYZ is excited to announce the appointment of Akshay Chopra as Chief Commercial Officer, effective
              immediately</span>
            <p>Akshay brings a wealth of expertise in the fintech and payments industry…</p>
            <a [routerLink]="['gennius-xyz-is-excited-to-announce-the-appointment-of-akshay-chopra']"
              [routerLinkActive]="['active']" class="more"></a>
          </div>
        </div>

      <div class="item">
        <div class="image">
          <img src="./assets/img/cryptmi/news15.png" alt="">
        </div>
        <div class="bl-text">
          <span class="date">Dec 04, 2024 </span>
          <span>Gennius Unveils ‘One’: A Streamlined Solution for Mid-Sized Loyalty Programs</span>
          <p>Gennius XYZ, has launched One, a unified wallet solution tailored…</p>
          <a [routerLink]="['gennius-unveils-one-a-streamlined-solution-for-mid-sized-Loyalty-programs']"
            [routerLinkActive]="['active']" class="more"></a>
        </div>
      </div>




      <div class="item">
        <div class="image">
          <img src="./assets/img/cryptmi/news14.png" alt="">
        </div>
        <div class="bl-text">
          <span class="date">Dec 03, 2024 </span>
          <span>Gennius XYZ Appoints Ruben Salazar Genovez as CEO and Investor to Drive Global Expansion</span>
          <p>Gennius XYZ, a global player in digital loyalty and rewards innovation…</p>
          <a [routerLink]="['gennius-xyz-appoints-ruben-salazar-genovez-as-ceo-and-investor-to-drive-global-expansion']" [routerLinkActive]="['active']" class="more"></a>
        </div>
      </div>



      <div class="item">
        <div class="image">
          <img src="./assets/img/cryptmi/news13.png" alt="">
        </div>
        <div class="bl-text">
          <span class="date">July 17, 2024 </span>
          <span>Announcing Voyage Connected World: A Landmark Collaboration with Consolid Global and Introduction of Imagine.</span>
          <p>We are excited to announce the launch of "Voyage Connected World”.</p>
          <a [routerLink]="['announcing-voyage-connected-world']" [routerLinkActive]="['active']" class="more"></a>
        </div>
      </div>

      <div class="item">
        <div class="image">
          <img src="./assets/img/cryptmi/news12.png" alt="">
        </div>
        <div class="bl-text">
          <span class="date">June 26, 2024 </span>
          <span>We are delighted to announce the appointment of Carolina as our new Managing Director for the Middle East, Africa, and Asia Pacific regions.</span>
          <p>Carolina, welcome to the Gennius XYZ family! </p>
          <a [routerLink]="['we-are-delighted-to-announce-the-appointment-of-carolina-as-our-new-managing-director']" [routerLinkActive]="['active']" class="more"></a>
        </div>
      </div>

      <div class="item">
        <div class="image">
          <img src="./assets/img/cryptmi/news11.png" alt="">
        </div>
        <div class="bl-text">
          <span class="date">May 9, 2024 </span>
          <span>Gennius XYZ launched its Gennius Global Hub at ‘The World as One’ event</span>
          <p>Dubai, UAE - May 2024 - The Lana Hotel's rooftop was abuzz with excitement on 9th May, as industry leaders, local
            press and professionals gathered for an impactful event aimed at fostering collaboration and innovation</p>
          <a [routerLink]="['gennius-xyz-launched-its-gennius-global-hub-at-the-world-as-one-event']"
            [routerLinkActive]="['active']" class="more"></a>
        </div>
      </div>

      <div class="item">
        <div class="image">
          <img src="./assets/img/cryptmi/news10.png" alt="">
        </div>
        <div class="bl-text">
          <span class="date">Aug 21, 2023 </span>
          <span>Gennius XYZ and Consolid Global Announce Extended Partnership and Investment to Revolutionize the Travel Industry with AI, Blockchain, and NFT</span>
          <p>DUBAI, August 2023* — Gennius XYZ, an innovative fintech leader in the payments, ecommerce, and loyalty…</p>
          <a [routerLink]="['gennius-xyz-and-consolid-global-announce-extended-partnership']" [routerLinkActive]="['active']" class="more"></a>
        </div>
      </div>

      <div class="item">
        <div class="image">
          <img src="./assets/img/cryptmi/news9.png" alt="">
        </div>
        <div class="bl-text">
          <span class="date">Aug 09, 2023 </span>
          <span>Welcome, Luis!</span>
          <p>We're thrilled to have you, the ultimate product hacker, as part of the <strong>Gennius</strong> team. </p>
          <a [routerLink]="['welcome-luis']" [routerLinkActive]="['active']" class="more"></a>
        </div>
      </div>

      <div class="item">
        <div class="image">
          <img src="./assets/img/cryptmi/news8.png" alt="">
        </div>
        <div class="bl-text">
          <span class="date">Aug 7, 2023 </span>
          <span>🚀 **Exciting Announcement for the Mexican Market!** 🌟</span>
          <p>We are delighted to announce the appointment of Francisco Delgado as Partner for the business development of “My Rewards
          – Visa Loyalty Solution” in the Mexican market. 🎉</p>
          <a [routerLink]="['exciting-announcement-for-the-mexican-market']" [routerLinkActive]="['active']" class="more"></a>
        </div>
      </div>

      <div class="item">
        <div class="image">
          <img src="./assets/img/cryptmi/news7.png" alt="">
        </div>
        <div class="bl-text">
          <span class="date">May 12, 2023 </span>
          <span>Seed Group onboards Gennius XYZ to transform the digital asset ecosystem in MENA</span>
          <p>Dubai, UAE; Florida, USA - Seed Group, a company of the Private Office of Sheikh Saeed Bin Ahmed Al Maktoum, has announced that it has onboarded Gennius XYZ, a fintech company with the aim of revolutionising the digital asset ecosystem.</p>
          <a [routerLink]="['seed-group-onboards-gennius-xyz-to-transform-the-digital-asset-ecosystem-in-mena']" [routerLinkActive]="['active']" class="more"></a>
        </div>
      </div>
      <div class="item">
        <div class="image">
          <img src="./assets/img/cryptmi/news6.png" alt="">
        </div>
        <div class="bl-text">
          <span class="date">Mar 27, 2023 </span>
          <span>Gennius XYZ Unveils Revolutionary CYMi Utility Token for Seamless Rewards and Payments Interoperability at Nexthon V</span>
          <p>MIAMI, FL &amp; DUBAI, UAE - Gennius XYZ, a prominent player in the smart-loyalty rewards and payments industry, has unveiled its latest innovative product, CYMi, a revolutionary base layer utility token.</p>
          <a [routerLink]="['gennius-xyz-unveils-revolutionary-cymi-utility-token-for-seamless-rewards-and-payments-interoperability-at-nexthon-v']" [routerLinkActive]="['active']" class="more"></a>
        </div>
      </div>
      <div class="item">
        <div class="image">
          <img src="./assets/img/cryptmi/news5.png" alt="">
        </div>
        <div class="bl-text">
          <span class="date">May 26, 2022</span>
          <span>cryptMi is on a mission to simplify the complex crypto card landscape</span>
          <p>At the recent Permissionless conference in West Palm Beach, there was one common refrain: Builders need to simplify their UX. While many founders share the aim to onboard millions of users into the web3 space, less tech savvy consumers still have trouble navigating crypto platforms.</p>
          <a href="https://refreshmiami.com/cryptmi-is-on-a-mission-to-simplify-the-complex-crypto-card-landscape/" target="_blank" class="more"></a>
        </div>
      </div>
      <div class="item">
        <div class="image">
          <img src="./assets/img/cryptmi/news1.png" alt="">
        </div>
        <div class="bl-text">
          <span class="date">May 17, 2022</span>
          <span>Real State - Global Unveiling of cryptMi Solution</span>
          <p>cryptMi unveils the world’s first dynamic card that allows you to blend all your digital assets to pay for everyday essentials, NFTs and purchases in the metaverse, by making dynamic and instant swaps between rewards</p>
          <a href="https://realstateinvestmentsintl.com/global-unveiling-of-cryptmi-solution/" target="_blank" class="more"></a>
        </div>
      </div>
      <div class="item">
        <div class="image">
          <img src="./assets/img/cryptmi/news2.png" alt="">
        </div>
        <div class="bl-text">
          <span class="date">May 17, 2022</span>
          <span>Lanzan novedosa cryptMi perfecta combinación recompensas, criptomonedas y monedas locales</span>
          <p>cryptMi presenta la primera tarjeta dinámica del mundo que le permite a los usuarios unificar todos sus activos digitales para realizar compras diarias, adquirir NFTs y hacer transacciones en el metaverso</p>
          <a href="http://elmundo-delosnegocios.com/lanzan-novedosa-cryptmi-perfecta-combinacion-recompensas-criptomonedas-y-monedas-locales/" target="_blank" class="more"></a>
        </div>
      </div>
      <div class="item">
        <div class="image">
          <img src="./assets/img/cryptmi/news3.png" alt="">
        </div>
        <div class="bl-text">
          <span class="date">May 16, 2022</span>
          <span>PRLOG - Global Unveiling of cryptMi Solution</span>
          <p>cryptMi unveils the world’s first dynamic card that allows you to blend all your digital assets to pay for everyday essentials, NFTs and purchases in the metaverse, by making dynamic and instant swaps between rewards</p>
          <a href="https://www.prlog.org/12917485-global-unveiling-of-cryptmi-solution.html" target="_blank" class="more"></a>
        </div>
      </div>
      <div class="item">
        <div class="image">
          <img src="./assets/img/cryptmi/news4.png" alt="">
        </div>
        <div class="bl-text">
          <span class="date">May 16, 2022</span>
          <span>Florida East Coast - Global Unveiling of cryptMi Solution</span>
          <p>cryptMi unveils the world’s first dynamic card that allows you to blend all your digital assets to pay for everyday essentials, NFTs and purchases in the metaverse, by making dynamic and instant swaps between rewards</p>
          <a href="http://floridalatamworldofbusiness.com/2022/05/16/global-unveiling-of-cryptmi-solution/" target="_blank" class="more"></a>
        </div>
      </div>





      <div  class="item second-item">
        <div class="image">
          <img src="./assets/img/cryptmi/item-press-28.png" alt="">

        </div>
        <div class="bl-text">
          <span class="date">Dic 30, 2021</span>
          <span>2021: the year of breakthroughs</span>
            <p>Our CEO Sergio Arana joined the latest eBook by PYMNTS.com, which brought together the points of view of qualified technology leaders around the world. In this edition, PYMNTS.com explores the recent explosion of technology innovations, accelerated by a whole new normal in post-pandemic digital consumption. </p>
            <a href="https://www.pymnts.com/news/2021/in-a-word-50-payments-execs-sum-up-2021" class="more"  target="_blank"></a>
        </div>
      </div>

      <div  class="item second-item">
        <div class="image">
          <img src="./assets/img/cryptmi/item-press-27.png" alt="">

        </div>
        <div class="bl-text">
          <span class="date">Dic 16, 2021</span>
          <span>Consumers Want to Buy Crypto, Spend Using Points From</span>
            <p>As digital adoption has accelerated over the past two years, so too have consumer expectations concerning the growing number of loyalty programs they now encounter.</p>
            <a href="https://www.pymnts.com/news/loyalty-and-rewards-news/2021/consumers-want-to-buy-crypto-spend-using-points-rewards-programs/" class="more"  target="_blank"></a>
        </div>
      </div>

      <div  class="item second-item">
        <div class="image">
          <img src="./assets/img/cryptmi/item-press-26.png" alt="">

        </div>
        <div class="bl-text">
          <span class="date">Nov 12, 2021</span>
          <span>Customer Loyalty Gets Boost From Offering Crypto Rewards</span>
            <p>It might seem as if buy now, pay later (BNPL) and cryptocurrency are being used everywhere, but there’s at least one big space where they have plenty of room to grow: loyalty programs.</p>
            <a href="https://www.pymnts.com/news/loyalty-and-rewards-news/2021/customer-loyalty-gets-boost-offering-crypto-rewards/" class="more"  target="_blank"></a>
        </div>
      </div>

      <div  class="item second-item">
        <div class="image">
          <img src="./assets/img/cryptmi/item-press-25.png" alt="">

        </div>
        <div class="bl-text">
          <span class="date">Oct 22, 2021</span>
          <span>Consumers Mull Switching Rewards to Cryptocurrency</span>
            <p>Where there is a will, there is a way. Provided there is also a clear understanding of what’s at the heart of a consumer’s interest in making a change.</p>
            <a href="https://www.pymnts.com/cryptocurrency/2021/consumers-mull-switching-rewards-to-cryptocurrency/" class="more"  target="_blank"></a>
        </div>
      </div>

      <div  class="item second-item">
        <div class="image">
          <img src="./assets/img/cryptmi/visa-banner.png" alt="">

        </div>
        <div class="bl-text">
          <span class="date">Sep 13, 2021</span>
          <span>novae, now member of Visa Fintech Partner Connect</span>
            <p>novae is now part of Visa Fintech Partner Connect, a program designed to leverage Visa’s issuing clients by quickly connecting them to a vetted set of technology partners.</p>
          <a [routerLink]="['novae-now-member-of-visa-fintech-partner-connect']" [routerLinkActive]="['active']" class="more"></a>
        </div>
      </div>

      <div  class="item second-item">
        <div class="image">
          <img src="./assets/img/cryptmi/item-press-24.png" alt="">

        </div>
        <div class="bl-text">
          <span class="date">Sep 09, 2021</span>
          <span>‘Super App as a Service’ Enables BNPL, Universal Rewards Redemptions, Including Crypto</span>
            <p>“People are ready to switch their rewards to crypto,” novae CEO Sergio Arana told PYMNTS.  With the help of Visa and a sweeping new rewards program, the company’s “Super App as a Service” platform will bring crypto transactions and buy now, pay later (BNPL) payments into the same stable as stalwarts like credit and debit cards for issuers to make available to their customers. </p>
          <a href="https://www.pymnts.com/pymnts-post/news/merchant-innovation/2021/super-app-as-a-service-enables-bnpl-universal-rewards-redemptions-including-crypto/?c=novae" class="more"  target="_blank"></a>
        </div>
      </div>

      <div  class="item second-item">
        <div class="image">
          <img src="./assets/img/cryptmi/bg-notice2-novae.png" alt="">

        </div>
        <div class="bl-text">
          <span class="date">Aug 13, 2021</span>
          <span>novae’s Voyage connected World is leveling up with Priceline Partner Networks</span>
            <p>The development of disruptive user experiences, coupled with a seamless customer journey, has always been a fundamental motto for novae’s solutions.</p>
          <a [routerLink]="['novaes-voyage-connected-world-is-leveling-up-with-priceline-partner-networks']" [routerLinkActive]="['active']" class="more"></a>
        </div>
      </div>

      <div  class="item second-item">
        <div class="image">
          <img src="./assets/img/cryptmi/bg-notice-novae.png" alt="">

        </div>
        <div class="bl-text">
          <span class="date">Jul 22, 2021</span>
          <span>The best thing that can happen to you since takeoff.</span>
            <p>Travelers have always been offered coverage, when what they’re truly looking for is Care. Today, we proudly announce that OGICO | AXA Global Health has become our latest global partner in alliance with Miles CareToday, we proudly announce that OGICO | AXA Global Health has become our latest global partner in alliance with Miles Care</p>
          <a [routerLink]="['the-best-thing-that-can-happen-to-you-since-takeoff']" [routerLinkActive]="['active']" class="more"></a>
        </div>
      </div>

      <div  class="item" *ngFor="let item of items" >
        <div class="image">
          <img [src]="item.img" alt="">

        </div>
        <div class="bl-text">
          <span class="date">{{item.date}}</span>
          <span>{{item.title}}</span>
          <p>{{item.description}}</p>
          <a [href]="item.link" target="_blank" class="more"></a>
        </div>
      </div>
    </div>
  </div>
</section>

<app-footer></app-footer>